import {
  DynamicScroller,
  DynamicScrollerItem,
  RecycleScroller,
} from "vue3-virtual-scroller";
import "vue3-virtual-scroller/dist/vue3-virtual-scroller.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("DynamicScroller", DynamicScroller);
  nuxtApp.vueApp.component("DynamicScrollerItem", DynamicScrollerItem);
  nuxtApp.vueApp.component("RecycleScroller", RecycleScroller);
});
